import React from 'react';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Switch, withRouter } from "react-router";
import PrivateRoute from '../../components/privateRoute';

import CustomizableMspSearch from "./customizableMspSearch";
import CustomizableMspReport from "./customizableMspReport";

// import "../../marketingList/unicorn.scss";
import "../search/relations/relationsSearch.scss";

class CustomizableMspLandingPage extends React.Component {
    render() {
        return (
            <div className="marketing-root">
                <Switch>
                    <PrivateRoute exact path={`${this.props.match.url}`} component={CustomizableMspSearch} componentProps={{ scroller: this.props.scroller }}/> 
                    <PrivateRoute exact path={`${this.props.match.url}/report/:entityId?`} component={CustomizableMspReport} componentProps={this.props} />
                </Switch>
            </div>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => ({ user: state.userContext })
)(CustomizableMspLandingPage)));
